<template>
  <div class="p-filtersA">
    <div class="p-filtersA__left" />
    <div class="p-filtersA__right">
      <div class="c-select">
        <select :value="selectedYear"
                :disabled="loading"
                @change="$emit('on-date-range-changed', { value: $event.target.value, type: 'year' })"
        >
          <option v-for="year in years" :key="'year_' + year.key" :value="year.value">
            {{ year.key }}
          </option>
        </select>
      </div>
      <div class="c-select">
        <select :value="selectedMonth"
                :disabled="loading"
                @change="$emit('on-date-range-changed', { value: $event.target.value, type: 'month' })"
        >
          <option v-for="month in months" :key="'month_' + month.key" :value="month.value">
            {{ month.key }}
          </option>
        </select>
      </div>
      <div class="from">
        {{ $t('pages.companies.analysis.qscas.until') }}
      </div>
      <div class="c-select">
        <select :value="selectedPeriod"
                :disabled="loading"
                @change="$emit('on-date-range-changed', { value: $event.target.value, type: 'period' })"
        >
          <option v-for="val in [3,6,9,12]" :key="'period_' + val" :value="val">
            {{ $t('pages.companies.analysis.qscas.period', { number: val }) }}
          </option>
        </select>
      </div>
      <!--        <div v-if="canExportAuthority('analysis/qscas') && providedFeaturesCsvExport">-->
      <!--          <button class="c-button__item c-button__item&#45;&#45;outline" @click.prevent="setExportCsv">-->
      <!--            {{ $t('labels.csvDownload') }}-->
      <!--          </button>-->
      <!--        </div>-->
      <router-link
        v-if="isDetailView"
        :to="{ name: 'CompaniesAnalysisQscas', params: { company_uuid: currentCompanyUuid } }"
        class="c-button__item c-button__item--outline"
        v-text="$t('labels.backToList')"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'CompaniesAnalysisQscasHeader',
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    'open-modal',
    'on-date-range-changed',
    'open-modal'
  ],
  computed: {
    ...mapGetters({
      providedFeaturesCsvExport: 'companiesCompany/providedFeaturesCsvExport',
      canExportAuthority: 'companiesAccessibleApi/canExportAuthority',
    }),
    ...mapState({
      selectedYear: state => state.companiesAnalysisQscas.selectedYear,
      selectedMonth: state => state.companiesAnalysisQscas.selectedMonth,
      selectedPeriod: state => state.companiesAnalysisQscas.selectedPeriod,
    }),
    currentCompanyUuid() {
      return this.$route.params.company_uuid
    },
    // QSCA詳細画面かどうか
    isDetailView() {
      return this.$route.path.includes('/analysis/qscas/detail')
    },
    years() {
      const thisYear = moment().year()
      const arr = []
      for (let i = 0; i < 3; i++) {
        arr.push({
          key: thisYear - i + '年',
          value: thisYear - i,
        })
      }
      return arr
    },
    months() {
      const arr = []
      for (let i = 1; i <= 12; i++) {
        arr.push({
          key: i + '月',
          value: i - 1,
        })
      }
      return arr
    },
  },
}
</script>

<style lang="scss" scoped>
.from {
  margin-left: 16px;
}
</style>
